/* * @Author: 曹俊杰 * @Date: 2024-09-22 14:55:48 * @Last Modified by: mikey.zhaopeng *
@Last Modified time: 2025-04-24 13:48:29 */余额
<template>
  <div class="box">
    <div class="ad">
      <el-image
        style="width: 818px; height: auto"
        :src="require('@/assets/image/ad/balance_1_content.webp')"
        fit="cover"
        @click="chaozhilibaoClick"
      ></el-image>
    </div>

    <div class="top">
      <div class="title">账号:{{ user.name }}（{{ user.phone }}）</div>
      <div class="bg">
        <div class="bg-t">我的余额</div>
        <div class="bg-b">
          <div class="value">
            <numberCount :targetNumber="user.balance" />
          </div>
          <div class="btn" @click="onclick">点击充值</div>
        </div>
      </div>
    </div>
    <ul class="menu defBorderRadius">
      <router-link
        v-for="item in menuList"
        class="item pointer"
        active-class="def-active"
        tag="li"
        :key="item.name"
        :to="`${item.name}`"
      >
        {{ item.title }}
        <div class="line"></div>
      </router-link>
      <div class="InvoiceBtn" @click="toInvoice">
        <img src="@/assets/image/Invoice/icon_1.webp" class="icon" alt="" srcset="" />
        <div>开发票</div>
      </div>
    </ul>
    <chongzhiDialog ref="chongzhiDialog" />

    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import chongzhiDialog from "@/components/chongzhiDialog";
import userinfo from "@/mixins/userinfo.js";

export default {
  mixins: [userinfo],
  components: {
    chongzhiDialog,
  },
  data() {
    return {
      menuList: [
        {
          title: "充值记录",
          name: "recharge",
        },
        {
          title: "消费记录",
          name: "expense",
        },
      ],
    };
  },
  mounted() {
    const { query } = this.$route;
    console.log(this.$route);
    if (query) {
      query.recharge && this.onclick();
    }
    this.$store.dispatch("user/getAccount");
  },
  methods: {
    onclick() {
      this.$refs.chongzhiDialog.show();
    },
    chaozhilibaoClick() {
      this.$store.dispatch("chaozhilibao/onShow");
    },
    toInvoice() {
      this.$router.push({ name: "Invoice" });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  flex-direction: column;
  .ad {
    height: 80px;
    width: 100%;
    margin-bottom: 16px;
    border-radius: 4px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(~@/assets/image/ad/balance_1.webp);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .top {
    background: #fff;
    padding-bottom: 20px;
    border-radius: 6px;

    .title {
      height: 60px;
      color: #262626;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 60px;
      padding-left: 20px;
    }

    .bg {
      border-radius: 4px;
      background: #f3f6f8;
      padding: 20px;
      margin: 0 20px;

      &-t {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      &-b {
        margin-top: 6px;
        display: flex;
        align-items: flex-end;

        .value {
          font-family: "Noto Sans SC";
          font-size: 40px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          color: #0062ff;
        }

        .btn {
          color: #0062ff;
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          line-height: 33px;
          margin-left: 20px;
          cursor: pointer;
        }
      }
    }
  }
}

.menu {
  margin-top: 16px;
  background: #fff;
  height: 60px;
  padding: 0 20px;
  flex: 1;
  display: flex;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 60px;
  position: relative;
  .item {
    margin-right: 40px;
    position: relative;
  }

  .def-active {
    color: #0062ff !important;

    .line {
      display: block;
      background: #0062ff;
    }
  }

  .line {
    width: 16px;
    height: 2px;
    border-radius: 8px;

    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: auto;
    display: none;
  }
  .InvoiceBtn {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 2px;

    font-size: 14px;
    font-weight: 350;
    color: #666666;
    line-height: 0px;
    .icon {
      width: 18px;
      height: 18px;
    }
    &:hover {
      color: #0062ff;
    }
  }
}
</style>
